var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomisableworkflow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 143.817,
    height: 143.82,
    viewBox: "0 0 143.817 143.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-workflow-5187847",
    transform: "translate(-3.302 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M286.438,149.612a2.954,2.954,0,0,0-2.088-.865H243.576a2.955,2.955,0,0,0-2.955,2.955v65a2.955,2.955,0,0,0,2.955,2.955h53.183a2.955,2.955,0,0,0,2.955-2.955V164.109a2.954,2.954,0,0,0-.865-2.089c-6.936-6.937-9.365-9.366-12.41-12.409Zm-1.5,46.408H255.394a2.955,2.955,0,1,1,0-5.909H284.94a2.955,2.955,0,1,1,0,5.909Zm2.955,8.863a2.955,2.955,0,0,1-2.955,2.955H255.394a2.955,2.955,0,1,1,0-5.909H284.94A2.955,2.955,0,0,1,287.895,204.884ZM284.94,184.2H255.394a2.955,2.955,0,1,1,0-5.909H284.94a2.955,2.955,0,1,1,0,5.909Zm-8.863-11.818H255.4a2.955,2.955,0,0,1,0-5.909h20.681a2.955,2.955,0,1,1,0,5.909Z",
    transform: "translate(-194.957 -113.292)",
    fill: "none",
    stroke: "#5fccf2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M140.111,465.94H134.2a2.955,2.955,0,1,0,0,5.909h5.909a2.955,2.955,0,1,0,0-5.909Z",
    transform: "translate(-115.128 -344.802)",
    fill: "none",
    stroke: "#5fccf2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M143.067,272.017a2.955,2.955,0,0,0-2.955-2.955H134.2a2.955,2.955,0,1,0,0,5.909h5.909A2.955,2.955,0,0,0,143.067,272.017Z",
    transform: "translate(-115.129 -201.106)",
    fill: "none",
    stroke: "#5fccf2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M346.1,17.5H316.558A2.955,2.955,0,0,0,313.6,20.45V32.268H261.647l.865-.865a2.955,2.955,0,1,0-4.179-4.179c-1.147,1.147-5.751,5.75-5.937,5.94a2.953,2.953,0,0,0,.027,4.148l5.909,5.909a2.955,2.955,0,0,0,4.179-4.179l-.865-.865H313.6V50a2.955,2.955,0,0,0,2.955,2.955H346.1A2.955,2.955,0,0,0,349.059,50V20.448a2.955,2.955,0,0,0-2.955-2.955ZM343.15,47.042H319.514V23.406H343.15Z",
    transform: "translate(-202.941 -17.494)",
    fill: "none",
    stroke: "#5fccf2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M527.957,78.1h5.909a2.955,2.955,0,0,0,0-5.909h-5.909a2.955,2.955,0,1,0,0,5.909Z",
    transform: "translate(-402.519 -57.412)",
    fill: "none",
    stroke: "#5fccf2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M501.929,243.864V191.656l.865.865a2.955,2.955,0,0,0,4.178-4.179l-5.909-5.909a2.958,2.958,0,0,0-4.179,0l-5.909,5.909a2.955,2.955,0,1,0,4.179,4.179l.865-.865v52.208a17.727,17.727,0,1,0,5.909,0Zm0,20.431H496.02a2.955,2.955,0,0,1,0-5.909h5.909a2.955,2.955,0,1,1,0,5.909Z",
    transform: "translate(-370.583 -137.248)",
    fill: "none",
    stroke: "#5fccf2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M184.132,139.5l-5.909-5.909a2.955,2.955,0,0,0-4.179,4.179l.865.865H122.953V126.812A2.955,2.955,0,0,0,120,123.858H108.181V106.13H120a2.955,2.955,0,0,0,2.955-2.955V73.629A2.955,2.955,0,0,0,120,70.675H108.181V52.7a17.727,17.727,0,1,0-5.909,0V70.675H90.454A2.955,2.955,0,0,0,87.5,73.629v29.547a2.955,2.955,0,0,0,2.955,2.955h11.818v17.727H90.454a2.955,2.955,0,0,0-2.955,2.955v29.547a2.955,2.955,0,0,0,2.955,2.955H120a2.955,2.955,0,0,0,2.955-2.955V144.541h51.956l-.865.865a2.955,2.955,0,0,0,4.179,4.179c1.147-1.148,5.751-5.75,5.937-5.94a2.954,2.954,0,0,0-.027-4.148ZM102.27,32.268h5.909a2.955,2.955,0,1,1,0,5.909H102.27a2.955,2.955,0,1,1,0-5.909ZM93.407,76.585h23.636v23.636H93.407ZM117.043,153.4H93.407V129.768h23.636Z",
    transform: "translate(-83.197 -17.493)",
    fill: "none",
    stroke: "#5fccf2",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomisableworkflow);
export default __webpack_public_path__ + "static/media/customisableworkflow.7186377fafd6b34a363436ff84eac09f.svg";
export { ForwardRef as ReactComponent };